import { mainScoutlyticsHomeUrl } from '../lsc/routing';
import { isLscAdminOnly } from '../config/featureFlags';
import { isAbsoluteLegalUrl, legalPageUrl } from '../legal/legalLinks';

export { isAbsoluteLegalUrl, legalPageUrl };

/** Signed-in dashboard (or empty-VOD marketing swap). */
export const STUDIO_HOME_PATH = '/studio';
/** Always renders the marketing landing — logo target. */
export const STUDIO_LANDING_PATH = '/studio/landing';

/**
 * Host-aware LSC entry URL.
 * When LSC_ADMIN_ONLY: always `/lsc` (COMING SOON / admin LSC) so `/` can be Studio.
 * Otherwise: stream.* → absolute https://scoutlytics.gg ; apex/www → in-app "/".
 */
export function studioLscHomeUrl(hostname?: string): string {
  if (isLscAdminOnly()) {
    return '/lsc';
  }
  return mainScoutlyticsHomeUrl(hostname);
}
